import { render, staticRenderFns } from "./RetoureList.vue?vue&type=template&id=f01a426c&scoped=true"
import script from "./RetoureList.vue?vue&type=script&lang=js"
export * from "./RetoureList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01a426c",
  null
  
)

export default component.exports